import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { APIs } from 'src/app/config/api.constant';
import { ApiService } from 'src/app/services/api.service';
import { AdminService } from './../services/admin.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-gst-charges',
  templateUrl: './gst-charges.component.html',
  styleUrls: ['./gst-charges.component.scss']
})
export class GstChargesComponent implements OnInit {
  gstForm: FormGroup;
  submitted = false;
  url: string;
  public showError1: boolean = false;
  public showError2: boolean = false;
  public showError3: boolean = false;
  public showError4: boolean = false;
  public percent1: number;
  public percent2: number;
  public percent3: number;
  public percent4: number;
  gstAdd: any;

  constructor(private _fb: FormBuilder, private http: HttpClient, private apiService: ApiService,
    private adminSrv: AdminService, private rolebasedactionService: RolebasedactionService,) { }

  ngOnInit() {
    this.gstAdd = this.rolebasedactionService.checkUserRolePermissionExits('GST:Create');
    this.loadGstForm();
    this.getGstDetails();
  }

  loadGstForm() {
    this.gstForm = this._fb.group({
      igst: ['', [Validators.required, Validators.pattern("^[0-9]+(\.[0-9]+)?$")]],
      cgst: ['', [Validators.required, Validators.pattern("^[0-9]+(\.[0-9]+)?$")]],
      sgst: ['', [Validators.required, Validators.pattern("^[0-9]+(\.[0-9]+)?$")]],
      // conFee: ['', [Validators.required, Validators.pattern("^[0-9]+(\.[0-9]+)?$")]],
    });
  }

  getGstDetails() {
    this.url = APIs.getGstDetails;
    this.apiService.get(this.url, '').subscribe((response) => {
      if (response != null) {
        const gstData = JSON.parse(response.data);
        this.gstForm.patchValue({
          igst: gstData.IGSTPercent,
          cgst: gstData.CGSTPercent,
          sgst: gstData.SGSTPercent,
          // conFee: gstData.ConvFeePercent
        });
      }
    },
      err => console.log('error', err));
  }

  get f() {
    return this.gstForm.controls;
  }

  onSubmit() {
    if (this.gstForm.valid) {
      const requestData =
      {
        CGSTPercent: this.gstForm.controls['cgst'].value,
        SGSTPercent: this.gstForm.controls['sgst'].value,
        IGSTPercent: this.gstForm.controls['igst'].value,
        // ConvFeePercent: this.gstForm.controls['conFee'].value,
      }
      this.adminSrv.saveComissionDetails(requestData).subscribe(
        (response: any) => {
          if (response.isValid) {
            window.location.reload();
          }
        },
        err => console.log('error', err));
    }
  }

  keyPressNumbersDecimal(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 46) {
      if (event.target.value.indexOf('.') !== -1) {
        event.preventDefault();
      }
    } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    } else if (event.target.value.indexOf('.') !== -1) {
      const value = event.target.value.split('.');
      if (value[1] && value[1].length >= 2) {
        event.preventDefault();
      }
    }
  }

  gstRange(event, inputNum) {
    const inputValue = event.target.value;
    const floatValue = parseFloat(inputValue);
    let showError = false;

    if (!isNaN(floatValue) && (floatValue < 0 || floatValue > 100)) {
      showError = true;
    } else if (inputValue.indexOf('.') !== -1) {
      const value = inputValue.split('.');
      if (value[0].length > 3 || value[1].length > 2 || parseFloat(inputValue) > 100) {
        showError = true;
      }
    } else if (inputValue.length > 3 || parseFloat(inputValue) > 100) {
      showError = true;
    }

    if (inputNum === 1) {
      this.showError1 = showError;
      if (!showError) {
        this.percent1 = parseFloat(inputValue);
      }
    } else if (inputNum === 2) {
      this.showError2 = showError;
      if (!showError) {
        this.percent2 = parseFloat(inputValue);
      }
    } else if (inputNum === 3) {
      this.showError3 = showError;
      if (!showError) {
        this.percent3 = parseFloat(inputValue);
      }
    }
    // else if (inputNum === 4) {
    //   this.showError4 = showError;
    //   if (!showError) {
    //     this.percent4 = parseFloat(inputValue);
    //   }
    // }
  }

}


